import { AuthProvider } from "@auth/AuthProvider";
import { RouterProvider } from "react-router-dom";
import { PermissionProvider } from "./contexts/PermissionContext";
import { ClientConfigProvider } from "./contexts/ClientConfigContext";
import ThemeProvider from "./contexts/ThemeContext";
import { router } from "./router";

function App() {
  return (
    <ThemeProvider>
      <PermissionProvider>
        <ClientConfigProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
        </ClientConfigProvider>
      </PermissionProvider>
    </ThemeProvider>
  );
}

export default App;
